import React, { Component } from "react";

const d = new Date().toLocaleDateString();

class Comments extends Component {

  render() {
    var comments = (this.props.comments ? this.props.comments : []);
    var thethis = this;
    var userStyle = {
      margin: 0
    }
    var fontStyle14 = {
      fontSize: 14
    }
    var fontStyle16 = {
      fontSize:16
    }

    return (
      comments.map(function(comment, i){
        return(
          <React.Fragment>
            <hr />
            <p style={userStyle}><b>{comment.userName}</b>  {"commentDate" in comment ? " - " + comment.commentDate.toLocaleDateString() : ""} </p>
            <p style={fontStyle14}>IGN: {comment.inGameName} </p>
            <p style={fontStyle16}>{comment.comment}</p>

          </React.Fragment>

        )
      })
    );
  }
}

export default Comments;



// WEBPACK FOOTER //
// ./src/Articles/Comments.js